"use client";

import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { CalendarIcon, UserWithoutBorder } from "../icons";
import { Skeleton } from "../ui/skeleton";
import { ChevronDown, Headset, Heart, LogOut } from "lucide-react";
import { logout } from "@/redux/slices/login.slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { dir } from "i18next";
import { useLocale, useTranslations } from "next-intl";
import { clearUser } from "@/redux/slices/user.slice";
import Link from "next/link";
import { cn } from "@/lib/utils";

const NavbarDropdown = ({
  setOpen,
  className,
}: {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const locale = useLocale();
  const t = useTranslations();

  const handleCloseDrawer = () => {
    if (setOpen) setOpen(false);
  };

  return (
    <DropdownMenu dir={dir(locale)}>
      <DropdownMenuTrigger
        className={cn(
          "flex items-center justify-between outline-none border bg-green-background p-4 rounded-2xl gap-2",
          className
        )}
      >
        <UserWithoutBorder />
        <span className="flex gap-1 items-center">
          {t("navbarDropdown.greeting")}{" "}
          {user?.firstName ? (
            user?.firstName
          ) : (
            <Skeleton className="h-5 w-10" />
          )}
        </span>
        <ChevronDown />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 rounded-2xl *:cursor-pointer *:gap-4 *:rounded-2xl p-4">
        <DropdownMenuItem asChild>
          <Link href={`/profile`} onClick={handleCloseDrawer} prefetch>
            <UserWithoutBorder />
            <span>{t("navbarDropdown.profile")}</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link onClick={handleCloseDrawer} href={`/favorites`} prefetch>
            <Heart className="fill-green-main stroke-green-main" />
            <span>{t("navbarDropdown.favorites")} </span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href={`/reservations`} onClick={handleCloseDrawer} prefetch>
            <CalendarIcon />
            <span>{t("navbarDropdown.myReservations")} </span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href={`/contact-us`} onClick={handleCloseDrawer} prefetch>
            <Headset />
            <span>{t("benefitsSection.contactUsButton")} </span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            dispatch(clearUser());
            dispatch(logout());
            handleCloseDrawer();
            
          }}
        >
          <LogOut />
          <span>{t("navbarDropdown.logout")} </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NavbarDropdown;
